import PropTypes from 'prop-types'
import classNames from 'classnames'

import Card from './card'
import Stats from './stats'
import Author from './author'
import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'
import { useBreakpoint } from '../../../../hooks/breakpoint'

const Header = ({ course, integrationSettings, ...attrs }) => {
  const breakpoint = useBreakpoint()

  return <section
    className={
      classNames([
        'bg-turquoise-50',
        'pt-16',
        'pb-6'
      ])
    }>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            '-mx-4',
            'flex',
            'flex-row',
            'flex-wrap'
          ])
        }>
        <div
          className={
            classNames([
              'px-4'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '66.666666%' : '100%'
          }}>
          <Typography
            size={'six'}
            weight={'black'}
            className={'mb-4'}>
            {course.title}
          </Typography>
          {
            course.summary.trim()
              ? <Typography
                tag={'div'}
                size={'three'}
                weight={'regular'}
                className={'mb-6'}>
                <RawHTML html={course.summary} />
              </Typography>
              : null
          }
          <Stats
            course={course}
            className={'mb-6'} />
          <Author
            course={course} />
        </div>

        {
          breakpoint.mdAndUp
            ? <div
              className={
                classNames([
                  'px-4',
                  'relative'
                ])
              }
              style={{
                flexBasis: breakpoint.mdAndUp ? '33.333333%' : '100%'
              }}>
              <Card
                course={course}
                className={'absolute w-full left-0 top-0'}
                style={{
                  marginBottom: '-100%'
                }}
                integrationSettings={integrationSettings} />
            </div>
            : null
        }
      </div>
    </div>
  </section>
}

Header.propTypes = {
  course: PropTypes.object,
  integrationSettings: PropTypes.object
}

export default Header
